import React from 'react'
import PropTypes from 'prop-types'

function LinkWithIcon (props) {
  if (props.iconPosition === 'right') {
    return (
      <a href={props.href} className='inline-flex items-center font-medium text-primary-500 hover:text-primary-400 focus:outline-none focus:underline transition ease-in-out duration-150'>
        <span>{props.text}</span>
        <svg className='-mr-1 ml-2 h-5 w-5' viewBox='0 0 20 20' fill='currentColor'>{props.iconPath}</svg>
      </a>
    )
  }

  return (
    <a href={props.href} className='inline-flex items-center font-medium text-primary-500 hover:text-primary-400 focus:outline-none focus:underline transition ease-in-out duration-150'>
      <svg className='-ml-1 mr-2 h-5 w-5' viewBox='0 0 20 20' fill='currentColor'>{props.iconPath}</svg>
      <span>{props.text}</span>
    </a>
  )
}

LinkWithIcon.defaultProps = {
  href: '#'
}

LinkWithIcon.propTypes = {
  /**
     * Button text
     */
  text: PropTypes.string.isRequired,
  /**
     * Link HREF attribute
     */
  href: PropTypes.string,
  /**
     * Icon SVG paths
     */
  iconPath: PropTypes.node.isRequired,
  /**
     * Icon position. Can be either 'left' or 'right'
     */
  iconPosition: PropTypes.string
}

export default LinkWithIcon
